import React, { useEffect, useState } from "react";
import { toJS } from "mobx";
import { useFormContext } from "../Form";
import { CheckedStates } from "../Checkbox";
import { observer } from "mobx-react-lite";
export const SelectAllTableCheckbox = observer(({ data, form, className, onChange, invert = false, dataTestId, dataId, totalDataLength, }) => {
    const { name } = form;
    const componentId = `${name}SelectAll`;
    const { values } = useFormContext();
    let collection = toJS(values.get(name));
    data =
        data?.map((row) => form.idIdentifier && row[form.idIdentifier]) ?? [];
    const someRowsAreInCollection = () => collection.filter((item) => data && data.includes(item));
    const allRowsAreInCollection = (data) => data.every((row) => collection.includes(row));
    const getCheckedState = () => {
        if (invert) {
            if (collection.length === totalDataLength) {
                return CheckedStates.Unchecked;
            }
            if (collection.length === 0) {
                return CheckedStates.Checked;
            }
            return CheckedStates.Indeterminate;
        }
        if (data && data.length && allRowsAreInCollection(data)) {
            return CheckedStates.Checked;
        }
        if (someRowsAreInCollection().length >= 1) {
            return CheckedStates.Indeterminate;
        }
        return CheckedStates.Unchecked;
    };
    const [checked, setChecked] = useState(getCheckedState());
    useEffect(() => setChecked(getCheckedState()), [collection]);
    const handleOnChange = () => {
        if (checked === CheckedStates.Checked) {
            collection = collection.filter((item) => data && !data.includes(item));
            values.set(name, collection);
        }
        else {
            const mergedArrays = data
                ? Array.from(new Set([...collection, ...data]))
                : collection;
            values.set(name, mergedArrays);
        }
        onChange && onChange(checked);
    };
    return (React.createElement("label", { className: className, "data-testid": dataTestId ?? "", "data-id": dataId ?? "" },
        React.createElement("input", { name: componentId, id: componentId, type: "checkbox", checked: checked === CheckedStates.Checked, ref: (el) => el && (el.indeterminate = checked === CheckedStates.Indeterminate), onChange: handleOnChange, "data-indeterminate": checked === CheckedStates.Indeterminate, disabled: !data || data.length === 0 }),
        React.createElement("span", { className: "sr-only" }, "Select all rows")));
});
